import { defineSlotRecipe } from '@chakra-ui/react';

import { checkmarkRecipe } from './checkmark.recipe';

export const checkboxSlotRecipe = defineSlotRecipe({
  className: 'chakra-checkbox',
  slots: ['label', 'root', 'control', 'indicator', 'group'],
  base: {
    root: {
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      verticalAlign: 'top',
      position: 'relative',
      height: '24px',
      gap: '2 !important',
    },
    label: {
      width: '100%',
      _hover: {
        cursor: 'pointer',
      },
      _disabled: {
        opacity: 1,
        cursor: 'default',
      },
      '&&:is([data-readonly])': {
        _hover: {
          cursor: 'default',
        },
      },
    },
    control: checkmarkRecipe.base,
  },
  variants: {
    size: {
      sm: {
        label: {
          textStyle: 'sm',
          fontWeight: 'regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
